/* istanbul ignore file */
import { FunctionComponent, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Divider, Grid } from '@material-ui/core';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import { getLiveDocumentViewUrl } from 'containers/UploadDocuments/utils';

import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import { get, isEmpty, isNil } from 'lodash';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import {
  DrawerDiv,
  DrawerContainer,
  StyledContainerCard,
} from 'containers/CourtManagerLegalProceedings/ImagineDocuments/style';
import {
  startLoading,
  stopLoading,
} from 'containers/AppContainer/Loader/action';
import DocumentCard from 'containers/CourtManagerLegalProceedings/ImagineDocuments/document';
import { extractImagineDocumentToImport } from 'containers/CourtManagerLegalProceedings/ImagineDocuments/utils';
import { useDispatch } from 'react-redux';
import { toDataUrl } from 'containers/UploadDocumentsManager/utils';
import { toast } from 'react-toastify';
import { DOCUMENT, EMPTY_DOCUMENT } from 'containers/data-structure';
import { setDocumentumId } from 'containers/UploadDocuments/actions';

export interface ImportDocumentImagingDrawerProps {
  intl: IntlShape;
  isDrawerOpen: boolean;
  setIsDrawerOpen: Function;
  listings: any;
  managerNotifcationsInboxes: any;
  claimId?: number;
  claimSagisInfo: any;
  uploadDocument: Function;
  uploadedDocument: { response: string } | {};
  setUploadedDocs: Function;
  documentName: any;
  documentType: any;
  setDocumentId: Function;
  documentId: any;
  imagineNotification: any;
  document?: any;
  setDisplayButton: Function;
  requestGetDocByDocumentumId: Function;
}

const ImportDocumentImagingDrawer: FunctionComponent<ImportDocumentImagingDrawerProps> = ({
  ...props
}): JSX.Element => {
  const dispatch = useDispatch();
  const [selecteDocument, setDocument] = useState([]);
  const [decisionOption, setDecisionOption] = useState(null);
  const handleToggleDrawer = () => {
    if (!isEmpty(props.uploadedDocument)) {
      props.setUploadedDocs({
        ...EMPTY_DOCUMENT,
        ...props.document,
        [DOCUMENT.IS_INDEXED]: true,
        [DOCUMENT.IS_VISIBLE]: true,
        [DOCUMENT.NAME]: props.documentName,
        [DOCUMENT.TYPE]: props.documentType,
        [DOCUMENT.URL]: get(props.uploadedDocument, 'response'),
        documentumId: selecteDocument,
        indexedAt: null,
      });
    }
    props.setIsDrawerOpen(!props.isDrawerOpen);
    props.setDisplayButton(false);
  };
  const handleClose = () => {
    props.setIsDrawerOpen(!props.isDrawerOpen);
  };
  const failedCallBack = () => {
    toast.error('document indisponible');
  };
  const DocumentNotificationImagine = !isEmpty(props.imagineNotification)
    ? props.managerNotifcationsInboxes
        .filter(
          (el: any) =>
            !isEmpty(el.documentImaging) &&
            isNil(get(el, 'treatedBy', null)) &&
            String(el.documentImaging.documentImagingId) ===
              String(
                get(
                  props.imagineNotification,
                  'documentImaging.documentImagingId',
                ),
              ),
        )
        .map((item: any) => item.documentImaging.documentImagingId)
    : !isEmpty(
        props.managerNotifcationsInboxes.filter(
          (el: any) =>
            isNil(get(el, 'treatedBy', null)) &&
            !isEmpty(el.documentImaging) &&
            el.claimId === Number(props.claimId),
        ),
      )
    ? props.managerNotifcationsInboxes
        .filter(
          (el: any) =>
            isNil(get(el, 'treatedBy', null)) &&
            !isEmpty(el.documentImaging) &&
            el.claimId === Number(props.claimId),
        )
        .map((item: any) => item.documentImaging.documentImagingId)
    : [];

  const handleValidate = async () => {
    dispatch(startLoading());
    dispatch(setDocumentumId(selecteDocument));
    if (!isEmpty(selecteDocument)) {
      const documentToUpload = extractImagineDocumentToImport(
        props.claimSagisInfo,
        DocumentNotificationImagine,
        props.listings,
      )
        .map((item: any) => ({
          isIndexed: true,
          documentId: item.DocumentID,
          type: item.DocumentType,
          fileName: item.fileName,
          path: item.path,
          dateDeCreation: item.dateCreation,
        }))
        .find((el: any) => el.documentId === selecteDocument);

      if (!isEmpty(documentToUpload)) {
        const doc = getLiveDocumentViewUrl(
          documentToUpload.path,
          documentToUpload.fileName,
          documentToUpload.isIndexed,
          documentToUpload.documentId,
        );
        const base64 = await toDataUrl(doc);
        props.uploadDocument(base64, failedCallBack);
        props.setDocumentId(props.documentId);
      }
    }
    dispatch(stopLoading());
    handleToggleDrawer();
  };
  const handleValidateDrawer = () => {
    handleValidate();
  };
  return (
    <DrawerContainer
      anchor="right"
      open={props.isDrawerOpen}
      onClose={handleClose}
    >
      <DrawerDiv>
        <div className="titleConatainer">
          <span className="title">
            {translate({ ...messages.topCardDocTitle }, props)}
          </span>

          <ClearOutlinedIcon data-testid={'close-icon'} onClick={handleClose} />
        </div>
        <Divider className="divider" />
        <div className="content">
          <Grid direction="row" container>
            <Grid item xs></Grid>

            <Grid item style={StyledContainerCard}>
              <Grid container direction="row" spacing={1}>
                {extractImagineDocumentToImport(
                  props.claimSagisInfo,
                  DocumentNotificationImagine,
                  props.listings,
                ).map((el: any) => (
                  <Grid item>
                    <DocumentCard
                      document={el}
                      toTreat={DocumentNotificationImagine.includes(
                        el.DocumentID,
                      )}
                      decisionItems={get(
                        props.listings,
                        'documentImagingDecisions',
                        [],
                      )}
                      setDecisionOption={(payload: any) => {
                        setDecisionOption(payload);
                      }}
                      decisionOption={decisionOption}
                      isImportDocument={true}
                      isConsultation={true}
                      selecteDocument={selecteDocument}
                      setDocument={setDocument}
                      notificationDocument={props.managerNotifcationsInboxes
                        .filter(
                          (element: any) =>
                            !isEmpty(element.documentImaging) &&
                            element.claimId === Number(props.claimId),
                        )
                        .find(
                          (item: any) =>
                            item.documentImaging.documentImagingId ===
                            el.DocumentID,
                        )}
                      requestGetDocByDocumentumId={
                        props.requestGetDocByDocumentumId
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className="actions">
          <Divider className="divider" />
          <div className="action-buttons-container">
            <SecondaryButton
              className="cancelButton"
              onClick={handleClose}
              title={translate({ ...messages.cancelBtn }, props)}
            />

            <PrimaryButton
              data-testid="primary-button"
              variant="contained"
              className={'saveButton'}
              onClick={handleValidateDrawer}
              title={'Telecharger'}
              disabled={false}
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={COLORS.WHITE}
            />
          </div>
        </div>
      </DrawerDiv>
    </DrawerContainer>
  );
};

export default injectIntl(ImportDocumentImagingDrawer);
